class videoWithBtn extends HTMLElement {
    constructor() {
      super();
  
       this.videoWithBtn = document.querySelector('video-with-btn');
       this.videoElement = this.videoWithBtn.querySelector('video');
       this.playPauseButton = this.videoWithBtn.querySelector('.cta-btn');
       this.videoElement.pause();
  
      this.bindEvents();
    }
  
    bindEvents(){
        this.playPauseButton.addEventListener('click', () => {
            this.playPauseButton.classList.toggle('playing');
            if (this.playPauseButton.classList.contains('playing')) {
                this.videoElement.play();
            }
            else {
                this.videoElement.pause();
            }
        });
        
        this.videoElement.addEventListener('ended', () => {
            this.playPauseButton.classList.remove('playing');
        });
    }

  }
  customElements.define("video-with-btn", videoWithBtn);